const CARD_BRAND_META = {
  visa: { label: 'Visa', assetName: 'visa' },
  mastercard: { label: 'Mastercard', assetName: 'mastercard' },
  amex: { label: 'American Express', assetName: 'amex' },
  discover: { label: 'Discover', assetName: 'discover' },
  unionpay: { label: 'UnionPay', assetName: 'unionpay' },
  jcb: { label: 'JCB', assetName: 'jcb' },
  diners: { label: 'Diners Club', assetName: 'diners' },
  eftposau: { label: 'eftpos', assetName: 'eftpos-au' },
  cartesbancaires: { label: 'Cartes Bancaires', assetName: 'cartes-bancaires' },
  unknown: { label: 'Card', assetName: 'generic-card' },
};

const CARD_BRAND_ALIASES = {
  americanexpress: 'amex',
  mastercard: 'mastercard',
  master: 'mastercard',
  dinersclub: 'diners',
  dinersclubinternational: 'diners',
  chinaunionpay: 'unionpay',
  unionpay: 'unionpay',
  eftposau: 'eftposau',
  cartesbancaire: 'cartesbancaires',
  cartesbancaires: 'cartesbancaires',
};

const logoPath = (assetName) => `${process.env.PUBLIC_URL || ''}/card-brands/${assetName}.svg`;

const cleanBrand = (brand = '') => String(brand).trim().toLowerCase().replace(/[\s_-]+/g, '');

export const normalizeCardBrand = (brand = '') => {
  const normalized = cleanBrand(brand);
  if (!normalized) return 'unknown';

  const key = CARD_BRAND_ALIASES[normalized] || normalized;
  return CARD_BRAND_META[key] ? key : 'unknown';
};

export const detectCardBrandFromNumber = (value = '') => {
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return 'unknown';

  const first2 = Number(digits.slice(0, 2));
  const first3 = Number(digits.slice(0, 3));
  const first4 = Number(digits.slice(0, 4));

  if (digits.startsWith('4')) return 'visa';
  if (digits.startsWith('34') || digits.startsWith('37')) return 'amex';

  if ((first2 >= 51 && first2 <= 55) || (first4 >= 2221 && first4 <= 2720)) {
    return 'mastercard';
  }

  if (digits.startsWith('6011') || digits.startsWith('65') || (first3 >= 644 && first3 <= 649)) {
    return 'discover';
  }

  if ((first3 >= 300 && first3 <= 305) || digits.startsWith('36') || digits.startsWith('38') || digits.startsWith('39')) {
    return 'diners';
  }

  if (first4 >= 3528 && first4 <= 3589) return 'jcb';
  if (digits.startsWith('62')) return 'unionpay';

  return 'unknown';
};

export const resolveCardBrand = ({ brand = '', number = '' } = {}) => {
  const normalizedBrand = normalizeCardBrand(brand);
  if (normalizedBrand !== 'unknown') return normalizedBrand;
  return detectCardBrandFromNumber(number);
};

export const getCardBrandMeta = (brand = '') => {
  const key = normalizeCardBrand(brand);
  const meta = CARD_BRAND_META[key] || CARD_BRAND_META.unknown;
  return { key, ...meta, logoSrc: logoPath(meta.assetName) };
};

export const getResolvedCardBrandMeta = ({ brand = '', number = '' } = {}) => {
  const key = resolveCardBrand({ brand, number });
  const meta = CARD_BRAND_META[key] || CARD_BRAND_META.unknown;
  return { key, ...meta, logoSrc: logoPath(meta.assetName) };
};

export const expectedCardBrandLogoFiles = Object.keys(CARD_BRAND_META)
  .filter((key) => key !== 'unknown')
  .map((key) => `${CARD_BRAND_META[key].assetName}.svg`);
